export default __webpack_public_path__ + "static/media/giftwrap.b0d7dcaf.svg";